import { connect } from 'react-redux';
import { Box, Flex, Text, Image } from '@chakra-ui/react';

import SignupImage from '../../styles/images/signup-icon.svg';
import LaunchdeckReferralImage from '../../styles/images/ld-referral.png';
import PrivacyTos from '../PrivacyTos';
import SignupForm from './SignupForm';
import { Link } from 'react-router-dom';

import LaunchdeckShortLogo from '../../../global/styles/images/launchdeck-short-logo-icon.png'


function OrganicSignupPageContent({
  prepopEmailDisplay,
  prepopNameDisplay,
  setShowSignupLoader,
  invitingUserProfile,
  // Redux
  signupOutcome,
}) {
  const { signupError, nextEvent, type, message } = signupOutcome.results || {};
  const signupProcessInProgress = (signupOutcome.loading === true) ? true : "";

  const renderPromptContent = () => {
    if (invitingUserProfile) {
      const { firstName } = invitingUserProfile || {};
      
      return (
        <>
          <Box mt='1em' mb='3em'>
            <Box fontSize='1.8em' color='brandDark.500' fontWeight='600'>{firstName} is inviting you to join them at Launchdeck</Box>
            <Box my='1em' fontSize='1.1em' color='brandDark.500' fontWeight='600'> 3 great reasons to use Launchdeck</Box>
            <Flex direction='column' gap='1em' fontSize='1em' color='gray.600' fontWeight='400'>
              <Flex gap='0.5em' justify='flex-start' align='center'>
                <LogoBulletPoint />
                <Box > Shorten your sales time-to-close</Box>
              </Flex>

              <Flex gap='0.5em' justify='flex-start' align='center'>
                <LogoBulletPoint />
                <Box> Seamless client onboarding, from Sales to Customer Success</Box>
              </Flex>

              <Flex gap='0.5em' justify='flex-start' align='center'>
                <LogoBulletPoint />
                <Box> Coordinate & align stakeholders all in one place </Box>
              </Flex>
            </Flex>
            <Box fontSize='1em' color='brandDark.500' fontWeight='600' mt='3em'> Join for free! </Box>
          </Box>

          <Flex w='100%' mb='2em' px='1em' justify='flex-start'>
            <Image w='25em' src={LaunchdeckReferralImage}></Image>
          </Flex>
        </>
      )
    } else {

      return (
        <>
          <Box mb='3em'>
            <Box fontSize='2em' lineHeight='3em' color='brandDark.500' fontWeight='600'>Get started for free</Box>
            <Box my='0.5em' fontSize='1.2em' color='brandDark.500' fontWeight='600'> Why you'd want to use Launchdeck</Box>

             <Flex direction='column' gap='1em' fontSize='0.9em' color='gray.600' fontWeight='400'>
              <Flex gap='0.5em' justify='flex-start' align='center'>
                <LogoBulletPoint />
                <Box > Shorten your sales time-to-close</Box>
              </Flex>

              <Flex gap='0.5em' justify='flex-start' align='center'>
                <LogoBulletPoint />
                <Box> Seamless client onboarding, from Sales to Customer Success</Box>
              </Flex>

              <Flex gap='0.5em' justify='flex-start' align='center'>
                <LogoBulletPoint />
                <Box> Coordinate & align stakeholders all in one place </Box>
              </Flex>

              <Box mt='0.75em'> ...and more! </Box>
            </Flex>

            {/* <Box w='100%' bg='white' mt='2em' rounded='0.5em' p='0.5em' fontSize='0.875em' border='1px solid' borderColor='brandPink.500'>
            <Flex fontWeight='600' gap={2}>{displayEmoji('celebrate')} Limited offer: Free trial codes</Flex>
            <Box mt='1em' color='brandDark.500'>If you want to try out unlimited features, we offer a 30-day free code inside</Box>
            <Box fontSize='0.75em' color='gray.500'>Cancel anytime, no questions asked</Box>
          </Box> */}
          </Box>

          <Flex w='100%' mt={['3em', '3em', '3em', '3em']} mb='2em' px='1em' justify='flex-start'>
            <Image src={SignupImage}></Image>
          </Flex>
        </>
      )

    }
  }

  return (
    <Flex maxW="1440px" direction={['column-reverse', 'row', 'row', 'row']} w='100%' px={['1em', '10em', '10em', '10em']} py='2em' justify='space-betweeen' align='stretch' margin='0 auto'>

      <Flex direction={['column-reverse', 'column', 'column', 'column']} justify='center' alignItems={['center', 'flex-start', 'flex-start', 'flex-start']} flex='1' px='2em'>
        {renderPromptContent()}
      </Flex>

      <Box flex='1' className='fade-in-left default-box-shadow' maxWidth={['', '37.5em', '37.5em', '37.5em']} rounded='0.25em'>

        <Flex direction='column' alignItems='center' bg='white' rounded='0.25em' h='100%' >
          <Box w='100%' px='3em' h='100%'>
            {!signupError && !signupProcessInProgress && <SignupForm
              userAcquisitionMethod={'Sign up page'}
              prepopEmailDisplay={prepopEmailDisplay}
              prepopNameDisplay={prepopNameDisplay}
              setShowSignupLoader={setShowSignupLoader}
              userProvidedInvalidEmail={nextEvent === "show-invalid-email-error" ? true : false}
            />}
            {signupError && type === 'Account already exists' && <ExistingAccountSignupError message={message} />}
          </Box>

          <Box borderTop='1px solid' borderColor='gray.300' w='100%' py='1em' px='2em'>
            <PrivacyTos />
          </Box>
        </Flex>
      </Box>
    </Flex>
  )

};

function ExistingAccountSignupError({ message }) {

  return (
    <Flex my='3%' minHeight='18em' justify='center' w={['90%', '100%', '100%', '100%']}>
      <Box fontSize='0.8em' borderWidth="1px" borderColor='pink.300' rounded={8} p='2%' my='auto'>
        <Text textAlign='center'>{message} </Text>
        <Link to="/reset-password">
          <Flex alignItems='baseline' justify='center'>
            <Text color='gray.500' textAlign='center' mt='1.5em' textDecoration='underline'>I had forgotten my password </Text>
            <span role="img" aria-label="shameful"> 😔 </span>
          </Flex>
        </Link>
      </Box>
    </Flex>
  )
}

function LogoBulletPoint() {
  return (
    <Image src={LaunchdeckShortLogo} alt="Launchdeck bullet point"  maxWidth='1.2em' />
  )
}



function mapStateToProps(state) {
  return {
    signupOutcome: state.auth.data.signup
  };
}


export default connect(mapStateToProps, null)(OrganicSignupPageContent);
